export default "__VITE_ASSET__h0uT1KUf__"